import React from 'react';
import ReferenceDF from '../components/SimulatorsComponents/DefualtSimulators/ReferenceDF';

//= ========================================================================

const Sim_G09_SplitPaymentReference = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <ReferenceDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_G09_SplitPaymentReference;
